<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
            <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">电脑列表</span>

                <el-tabs v-model="activeCampusId" @tab-click="clickTab" type="card" >
                  <el-tab-pane :key="item.Id" v-for="item in campusListData" :name="item.Id.toString()">
                    <span slot="label"> {{item.Name}} </span>

                    <el-row class="grid-content">
                      <el-col>
                        <el-button type="primary" class="add-computer-btn"  icon="el-icon-plus" @click="saveComputer(null)">添加电脑</el-button>
                      </el-col>
                      <el-col>
                        <br>
                      </el-col>
                      <el-col>
                        <el-table ref="computerListData"
                          :cell-class-name="cellStyle"
                          v-loading="loading"
                          :data="currentComputerList"
                          :default-sort="{prop: 'ComputerName', order: 'ascending'}"
                          :header-row-class-name="'el-table-header'"
                        >
                          <el-table-column prop="ComputerName" label="名称" width="400"></el-table-column>
                          <el-table-column prop="IsActiveString" label="状态" width="100"></el-table-column>
                          <el-table-column prop="UnavailableTimeSchedulesText" label="不可用时间段" width="400"></el-table-column>
                          <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                              <el-button type="text" size="small" @click="saveComputer(scope.row)">编辑</el-button>
                              <el-button type="text" size="small" @click="deleteComputer(scope.row)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-col> 
                    </el-row>
                  </el-tab-pane>
                </el-tabs>                                    
                <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="dialogEditorVisible" top="8vh" @close="onCloseEditor">
                  <computerEditor ref="computerEditor" :currentCampusId="activeCampusId" :data="editData" @saveSuccess="onSaveSuccess"></computerEditor>
                </el-dialog>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.add-computer-btn {
    margin-left: 10px;
    background-color: #59c2e6 !important;
    border-color: #59c2e6 !important;
}

.grid-content {
    /deep/ .el-table .cell {
      white-space: pre-line;
    }
}
</style>
<script>
import navigator from "../../components/navigator";
import computerEditor from "../../components/computerEditor";
import { getCampusList, getComputerList, removeComputer } from "../../service/common.service";

export default {
  data() {
    return {
      activeCampusId:"1",
      campusListData:[],
      computerListData:[], 
      loading:false,
      editData:{},
      currentComputerList:[],
      dialogEditorVisible: false, 
    };
  },
  components: {
    navigator,    
    computerEditor
  },
  computed: {

  },
  async created() {
    await this.loadCampusList();
    if (!!this.campusListData && this.campusListData.length > 0) {
      this.activeCampusId = this.campusListData[0].Id.toString();
    }
    this.loadComputerList();
  },
  methods: {
    loadComputerList(){
      if (this.loading) {
        return;
      }
      this.loading = true;      
      getComputerList().then(result => {
        if(!!result && result.success){
          this.computerListData = result.data;
          this.loadComputerListByCampusId();
        }
        
        this.loading = false;
      });
    },
    async loadCampusList(){
      let result = await getCampusList();
      if (!!result && result.success) {
        this.campusListData = result.data;
      }
    },
    loadComputerListByCampusId(){
      if(!!this.computerListData && this.computerListData.length > 0){
        this.currentComputerList = this.computerListData.filter(c=>c.CampusId == this.activeCampusId);
      }
    },
    clickTab() {
      this.loadComputerListByCampusId();
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    saveComputer(row){
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    deleteComputer(row){
      if (!!row) {
        this.$confirm("您确定要删除该电脑吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (row.Id > 0) {
            removeComputer(row.Id).then(result => {
              if (result.success) {
                this.loadComputerList();
              } else {
                this.$message.error(result.message);
              }
            });
          }
        })
        .catch(() => {});
      }
    },
    onCloseEditor(){
      this.dialogEditorVisible = false;
      if (!!this.$refs["computerEditor"])
        this.$refs["computerEditor"].resetFields();
    }, 
    onSaveSuccess(){
      this.dialogEditorVisible = false;
      this.loadComputerList();
    },
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/computerList.vue